import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { Layout } from "./shared/ui/Layout";
import { AuthGate } from "./shared/auth/AuthGate";
import { AuthProvider } from "./shared/auth/AuthProvider";
import { HomeRoute } from "./routes/HomeRoute";
import { ExportRoute } from "./routes/ExportRoute";
import { LoginRoute } from "./routes/LoginRoute";
import { NotFoundRoute } from "./routes/NotFoundRoute";

export function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Layout>
          <Routes>
            <Route path="/" element={<HomeRoute />} />
            <Route path="/login" element={<LoginRoute />} />
            <Route
              path="/export"
              element={
                <AuthGate>
                  <ExportRoute />
                </AuthGate>
              }
            />
            <Route path="/404" element={<NotFoundRoute />} />
            <Route path="*" element={<Navigate to="/404" replace />} />
          </Routes>
        </Layout>
      </BrowserRouter>
    </AuthProvider>
  );
}
